/* eslint-disable no-shadow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { growlErrors } from '../../../utils/NotificationUtil';
import { Loading } from '../../../components/Loading';
import { withGrowl } from '../../../components/GrowlNotifications';
import {
  growlShape,
} from '../../../components/prop-types';

import { withAccount } from '../../../components/AccountContext';

import { VIEWER_LOCALE } from '../../../components/Query';

import TransferForm from './TransferForm';

export const CURRENT_ACCOUNT_QUERY = gql`
  query ($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName
      creditBalance {
        id
        totalIn
        totalOut
        consumption
        balance
      }
    }
  }
`;

export const NEW_TRANFER_MUTATION = gql`
  mutation NewTransfer($input: TransferCreditsInput!) {
    transferCredits(input: $input) {
      transfer {
        id
        amount
        transferReason
        transactionTime
      }
      creditThresholdReached
    }
  }
`;

class TransfersQuery extends Component {
  static propTypes = {
    currentAccount: PropTypes.number.isRequired,
  };

  render() {
    const { currentAccount, growl } = this.props;

    const variables = {
      accountId: currentAccount,
    };

    return (
      <Query query={VIEWER_LOCALE}>
        {({ data, loading, error }) => {
          if (loading) {
            return <Loading />;
          }
          if (error) {
            growlErrors(growl, error);
          }

          const locale = data && data.viewer ? data.viewer.locale : 'en';

          return (
            <Query query={CURRENT_ACCOUNT_QUERY} variables={variables}>
              {({ data, loading, error }) => {
                if (error) {
                  return (
                    <p>
      ERROR:
                      {JSON.stringify(error)}
                    </p>
                  );
                }
                if (loading) return <p>Loading...</p>;

                const account = data && data.account ? data.account : { id: currentAccount, label: 'CurrentAccount' };

                return (
                  <Mutation mutation={NEW_TRANFER_MUTATION}>
                    {transferCredits => (
                      <TransferForm
                        account={account}
                        loading={loading}
                        transferCredits={transferCredits}
                        locale={locale}
                      />
                    )}
                  </Mutation>
                );
              }}
            </Query>
          );
        }}
      </Query>
    );
  }
}

TransfersQuery.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(withRouter(injectIntl(withAccount(TransfersQuery))));
